import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Select, Button, InputNumber} from 'antd'
import ExecuteTable from './ExecuteTable'
import {toJS} from 'mobx'
import {withTranslation} from 'react-i18next'

@inject('jobManagementStore', 'mappingManagementStore')
@observer
class FormModal extends Component {
  state = {
    inboundValue: '',
    outboundValue: '',
    hiddenByJobType: true,
    inBoundDisable: '',
    outBoundDisable: '',
    executeVisible: false,
    executeData: [],
    inboundMultiple: [],
    isSimultaneous: false
  }

  formRef = React.createRef()

  componentDidMount() {
    const {jobManagementStore, mappingManagementStore, title} = this.props
    const {detailsObj} = jobManagementStore
    const {inboundNameList} = mappingManagementStore
    const newInboundArray = []

    if (title === 'edit') {
      this.setState({hiddenByJobType: detailsObj?.jobType === '1', executeVisible: detailsObj?.jobType === '3'})
      if (detailsObj?.jobType === '1') {
        this.independentBound('INBOUND', detailsObj?.inboundCustomer)
        this.independentBound('OUTBOUND', detailsObj?.outboundCustomer)
      } else if (detailsObj?.jobType === '2') {
        this.onChangeInbound(detailsObj?.inboundCustomer)
        this.onChangeOutbound(detailsObj?.outboundCustomer)
      } else {
        this.onChangeInbound(detailsObj?.inboundCustomer, true)
      }

      if (detailsObj?.jobType !== '3') {
        this.formRef.current.setFieldsValue({
          'jobName': detailsObj?.jobName,
          'jobType': detailsObj?.jobType,
          'inboundApiConfigId': detailsObj?.inboundApiConfigId,
          'inboundCustomer': detailsObj?.inboundCustomer,
          'outboundApiConfigId': detailsObj?.outboundApiConfigId,
          'outboundCustomer': detailsObj?.outboundCustomer,
          'timeRange': detailsObj?.timeRange
        })
      } else {
        detailsObj.inboundApiConfigId.forEach((subItem) => {
          inboundNameList.forEach(item => {
            if (item.id === subItem) {
              item.key = item.id
              item.value = item.id
              item.label = item.apiName
              newInboundArray.push(toJS(item))
            }
          })
        })

        newInboundArray.forEach((item, index) => {
          item.index = index + 1
        })
        this.formRef.current.setFieldsValue({
          ...detailsObj,
          'inboundCustomer': toJS(detailsObj.inboundCustomer),
          'inboundApiConfigId': newInboundArray,
        })
        this.setState({executeData: newInboundArray, isSimultaneous: detailsObj?.jobType === '3' && detailsObj?.executeType === '2'})
      }
    }
  }

  handleOk = () => {
    const {jobManagementStore, handleCancel, title} = this.props
    const {detailsObj} = jobManagementStore
    let newInbound = []

    this.formRef.current.validateFields().then(fieldsValue => {
      if (fieldsValue.jobType === '3') {
        newInbound = fieldsValue.inboundApiConfigId.map(item => item.value).join(';')
        fieldsValue.inboundApiConfigId = newInbound
        fieldsValue.inboundCustomer = fieldsValue.inboundCustomer.join(';')
      }

      if (title === 'edit') {
        jobManagementStore.onAddJobAction({...fieldsValue, id: detailsObj.id}, title)
      } else {
        jobManagementStore.onAddJobAction({...fieldsValue, jobStatus: 0})
      }
      handleCancel()
    }).catch(() => {})

  }

  /*inboundCustomer*/
  onChangeInbound = (value, isMultiple = false, type = 'notInbound') => {
    const {mappingManagementStore} = this.props
    const {executeData, inboundMultiple} = this.state
    if (!isMultiple) {
      this.formRef.current.setFieldsValue({
        inboundApiConfigId: undefined
      })
      mappingManagementStore.onGetInboundNameAction(value, false, type)
      this.setState({
        inboundValue: value
      })
      if (value === undefined) {
        this.setState({
          inboundValue: ''
        })
      }
    } else {
      const finalInbound = []
      const mapRes = new Map()
      let currentInbound = []
      const multipleParams = value.join(';')
      mappingManagementStore.onGetInboundNamesAction({ids: multipleParams}).then(res => {
        this.setState({inboundMultiple: res})
      })

      executeData.forEach(item => {
        inboundMultiple.forEach(subItem => {
          if (item.value === subItem.id) {
            currentInbound.push(subItem)
          }
        })
      })

      currentInbound = currentInbound.filter((item) => !mapRes.has(item['id']) && mapRes.set(item['id'], 1))
      currentInbound.forEach(item => {
        value.forEach(subItem => {
          if (item.customer === subItem) {
            finalInbound.push(item)
          }
        })
      })

      finalInbound.forEach(item => {
        item.value = item.id
        item.label = item.apiName
        item.key = item.id
      })
      if (finalInbound.length > 0) {
        this.onMultipleInboundChange(finalInbound)
        this.formRef.current.setFieldsValue({inboundApiConfigId: finalInbound})
      } else {
        this.setState({executeData: []})
        this.formRef.current.setFieldsValue({inboundApiConfigId: []})
      }

      if (value === []) {
        this.setState({
          inboundValue: []
        })
      }
    }
  }

  /*outboundCustomer*/
  onChangeOutbound = (value) => {
    const {mappingManagementStore} = this.props
    this.formRef.current.setFieldsValue({
      outboundApiConfigId: undefined
    })
    mappingManagementStore.onGetOutboundNameAction(value)
    this.setState({
      outboundValue: value
    })
    if (value === undefined) {
      this.setState({
        outboundValue: ''
      })
    }
  }

  onJobTypeChanged = e => {
    this.formRef.current.setFieldsValue({
      inboundCustomer: [],
      outboundCustomer: [],
      inboundApiConfigId: [],
      outboundApiConfigId: [],
      executeType: []
    })
    this.setState({
      inBoundDisable: '',
      outBoundDisable: '',
      executeData: []
    })
    if (e === '1') {
      this.setState({hiddenByJobType: true, executeVisible: false})
    } else if (e === '2') {
      this.setState({hiddenByJobType: false, executeVisible: false})
    } else {
      this.setState({hiddenByJobType: false, executeVisible: true})
    }
  }

  // inBoundName/outBoundName独立接口
  independentBound = (directionType, id) => {
    const {jobManagementStore} = this.props
    const stateId = id || ''
    jobManagementStore.getNameDropdown(directionType, id).then(() => {
      if (directionType === 'INBOUND') {
        this.setState({inBoundDisable: stateId})
        this.formRef.current.setFieldsValue({
          inboundApiConfigId: undefined
        })
      } else {
        this.setState({outBoundDisable: stateId})
        this.formRef.current.setFieldsValue({
          outboundApiConfigId: undefined
        })
      }
    })
  }

  orderIndex = data => {
    data.forEach((item, index) => {
      item.index = index + 1
    })
    return data
  }

  onMultipleInboundChange = e => {
    this.setState({executeData: this.orderIndex(e)})
  }

  deleteTableData = index => {
    const originData = JSON.parse(JSON.stringify(this.formRef.current.getFieldValue('inboundApiConfigId')))
    originData.splice(index, 1)
    this.formRef.current.setFieldsValue({inboundApiConfigId: originData})
    this.setState({executeData: this.orderIndex(originData)})
  }

  moveUpTableData = index => {
    const originData = JSON.parse(JSON.stringify(this.formRef.current.getFieldValue('inboundApiConfigId')))
    if (originData.length <= 1 || index === 0) return
    const newData = originData.splice(index, 1)
    originData.splice(index - 1, 0, newData[0])
    this.formRef.current.setFieldsValue({inboundApiConfigId: originData})
    this.setState({executeData: this.orderIndex(originData)})
  }

  moveDownTableData = index => {
    const originData = JSON.parse(JSON.stringify(this.formRef.current.getFieldValue('inboundApiConfigId')))
    if (originData.length <= 1 || index === originData.length - 1) return
    const newData = originData.splice(index, 1)
    originData.splice(index + 1, 0, newData[0])
    this.formRef.current.setFieldsValue({inboundApiConfigId: originData})
    this.setState({executeData: this.orderIndex(originData)})
  }

  onExecuteTypeChange = e => {
    this.setState({isSimultaneous: e === '2'})
  }

  render() {
    const {jobManagementStore, mappingManagementStore, addModalVisible, handleCancel, title, t} = this.props
    const {inboundCustomerList, inboundNameList, outboundCustomerList} = mappingManagementStore
    const {jobType, inBoundNameList, outBoundNameList, executeTypes} = jobManagementStore
    const {hiddenByJobType, executeVisible, executeData, isSimultaneous} = this.state
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`job.editJob`) : t(`job.addJob`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          width="70%"
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="jobType" label={t(`job.jobType`)}
                           rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.jobType`)}`}]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onJobTypeChanged} showSearch
                          disabled={this.props.title === 'edit'}>
                    {jobType?.map(item => (
                      <Select.Option key={item.code} value={item.code}>{item.label}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                <Form.Item name="jobName" label={t(`job.jobName`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`job.jobName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\]*$/)
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} disabled={this.props.title === 'edit'}/>
                </Form.Item>
              </Col>
              {/*调用通用接口的Inbound: */}
              {
                (!hiddenByJobType && !executeVisible) ?
                  <>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="inboundCustomer" label={t(`job.inboundCustomer`)}
                                 rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.inboundCustomer`)}`}]}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear
                                onChange={e => this.onChangeInbound(e, false, 'inbound')} showSearch>
                          {inboundCustomerList.length > 0 ? inboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                           value={item.id}>{item.customer}</Select.Option>) : null}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="inboundApiConfigId" label={t(`job.inboundName`)}
                                 rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.inboundName`)}`}]}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch>
                          {inboundNameList.map(item => <Select.Option key={item.id}
                                                                      value={item.id}>{item.apiName}</Select.Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                  </> : (hiddenByJobType && !executeVisible) ?
                    <>
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="inboundCustomer" label={t(`job.inboundCustomer`)}
                                   rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.inboundCustomer`)}`}]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear
                                  onChange={e => this.independentBound('INBOUND', e)} showSearch>
                            {inboundCustomerList.length > 0 ? inboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                             value={item.id}>{item.customer}</Select.Option>) : null}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="inboundApiConfigId" label={t(`job.inboundName`)}
                                   rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.inboundName`)}`}]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch>
                            {inBoundNameList.map(item => <Select.Option key={item.id}
                                                                        value={item.id}>{item.apiName}</Select.Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="outboundCustomer" label={t(`job.outboundCustomer`)}
                                   rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.outboundCustomer`)}`}]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear
                                  onChange={e => this.independentBound('OUTBOUND', e)} showSearch>
                            {outboundCustomerList.length > 0 ? outboundCustomerList.map(item => <Select.Option
                              key={item.id}
                              value={item.id}>{item.customer}</Select.Option>) : null}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="outboundApiConfigId" label={t(`job.outboundName`)}
                                   rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.outboundName`)}`}]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch>
                            {outBoundNameList.length > 0 ? outBoundNameList.map(item => <Select.Option key={item.id}
                                                                                                       value={item.id}>{item.apiName}</Select.Option>) : null}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="timeRange" label={t(`job.timeRange`)}
                                   initialValue="0"
                                   rules={[{
                                     required: true,
                                     message: `${t(`general.pleaseEnter`)} ${t(`job.timeRange`)}`,
                                     pattern: new RegExp(/^[0-9]*[0-9][0-9]*$/)
                                   }]}>
                          <Input min={0} type="number" placeholder="0" prefix="EX" suffix="Day" className="typeNumber"/>
                        </Form.Item>
                      </Col>
                    </> :
                    <>
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="inboundCustomer" label={t(`job.inboundCustomer`)}
                                   rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.inboundCustomer`)}`}]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear
                                  onChange={e => this.onChangeInbound(e, true)} showSearch mode="multiple" maxTagCount="responsive"
                                  maxTagTextLength={10}>
                            {inboundCustomerList.length > 0 ? inboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                             value={item.id}>{item.customer}</Select.Option>) : null}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                        <Form.Item name="inboundApiConfigId" label={t(`job.inboundName`)}
                                   rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.inboundName`)}`}]}>
                          <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onMultipleInboundChange} showSearch mode="multiple"
                                  maxTagCount="responsive" maxTagTextLength={10}
                                  labelInValue getPopupContainer={triggerNode => triggerNode.parentElement}>
                            {inboundNameList.map(item => <Select.Option key={item.id}
                                                                        value={item.id}>{item.apiName}</Select.Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                    </>
              }
              {
                executeVisible ?
                  <>
                    <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                      <Form.Item name="executeType" label={t(`job.executeType`)}
                                 rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`job.executeType`)}`}]}>
                        <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch onChange={this.onExecuteTypeChange}>
                          {executeTypes.length > 0 ? executeTypes.map(item => <Select.Option key={item.code}
                                                                                             value={item.code}>{item.label}</Select.Option>) : null}
                        </Select>
                      </Form.Item>
                    </Col>
                    {
                      isSimultaneous ?
                        <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} span={6}>
                          <Form.Item name="parallelQuantity" label={t(`job.parallelQuantity`)}>
                            <InputNumber min={0} max={executeData.length > 10 ? 10 : executeData.length} precision={0} style={{width: '100%'}}/>
                          </Form.Item>
                        </Col> : null
                    }
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                      <ExecuteTable dataSource={executeData} onDelete={this.deleteTableData.bind(this)} onUp={this.moveUpTableData.bind(this)}
                                    onDown={this.moveDownTableData.bind(this)}/>
                    </Col>
                  </> : null
              }
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
